import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AdminSidebar from './components/AdminSidebar';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProductsPage from './pages/ProductsPage';
import SettingsPage from './pages/SettingsPage';
import UsersPage from './pages/UsersPage';
import QuotesPage from './pages/QuotesPage';
import ProjectsPage from './pages/ProjectsPage';
import ClientsPage from './pages/ClientsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import BannersPage from './pages/BannersPage';
import SocialProjectsPage from './pages/SocialProjectsPage';
import BanksPage from './pages/BanksPage';
import NewsPage from './pages/NewsPage';
import EventsAdminPage from './pages/EventsPage';
import LeadsPage from './pages/LeadsPage';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-emerald-500/30 border-t-emerald-500 rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

const AdminLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  return (
    <div className="min-h-screen bg-zinc-950 flex">
      <AdminSidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
      <main className={`flex-1 p-6 lg:p-8 overflow-auto transition-all duration-300 ${sidebarCollapsed ? 'lg:ml-0' : ''}`}>
        {children}
      </main>
    </div>
  );
};

const AdminRoutes = () => {
  const { isAuthenticated, login } = useAuth();
  
  // Si no está autenticado, mostrar login
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage onLogin={login} />} />
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    );
  }
  
  // Si está autenticado, mostrar el dashboard
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/quotes" element={<QuotesPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/banners" element={<BannersPage />} />
        <Route path="/social-projects" element={<SocialProjectsPage />} />
        <Route path="/banks" element={<BanksPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/events" element={<EventsAdminPage />} />
        <Route path="/login" element={<Navigate to="/admin" replace />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminLayout>
  );
};

const AdminApp = () => {
  return (
    <AuthProvider>
      <AdminRoutes />
    </AuthProvider>
  );
};

export default AdminApp;
